// The Privacy Policy, Terms of Service and Cookie Notice are served only by the marketing site
// (valutten.com), rendered from valutten-marketing content/legal/*.md. The app holds no copy:
// in-app links point here, and app.valutten.com/{privacy,terms,cookies} 301 here (firebase.json).
export const LEGAL_URLS = {
  privacy: 'https://valutten.com/privacy',
  terms: 'https://valutten.com/terms',
  cookies: 'https://valutten.com/cookies',
} as const;
